import { fetchData } from '../../../modules/fetchData.js';
import { renderMovies } from '../../../modules/renderMovies.js';
// import { createPagination } from '../../modules/pagination.js';

import movies from '../JSON/programma.json';

// const path = './JSON/programma.json';
// let data = [];
const movieContainer = document.querySelector(".movie-container");

// async function getFetchedData() {
//     let data = await fetchData(path);;
//     return data;
// }

// data.push(await getFetchedData());

// let movies = data[0];

movieContainer.appendChild(renderMovies(movies, 1, "Attori", "Durata", "Regia"));
// pagination.appendChild(createPagination(movies, 1));